module.exports = __webpack_public_path__ + "img/process-5.e31c3356.png";